import getConfig from 'next/config'
import { convertFiltersToUrlParams } from './helpers'

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

export const getNotifications = async (apiFilters) => {
  try {
    const filterParams = convertFiltersToUrlParams(apiFilters)
    const apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/notifications?${filterParams}`

    const response = await fetch(apiUrl)

    if (!response.ok) {
      throw `getNotifications failed: ${response.status} ${response.statusText}`
    }

    const responseJSON = await response.json()

    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

export const getNotificationByMachineName = async (cookie, machineName) => {
  try {
    const apiUrl = `${serverRuntimeConfig.adminApiBaseUrl}/api/v1/notifications/byMachineName/${machineName}`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })

    if (!response.ok) {
      throw `getNotificationByMachineName failed: ${response.status} ${response.statusText}`
    }

    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

/* Client Side APIs */
export const getUserNotifications = async (includeIsMuted = false, cookie) => {
  try {
    let apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/notifications?includeMuted=true`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && { cookie }
    })

    if (!response.ok) {
      throw `fetch getUserNotifications failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const seenUserNotifications = async (notifications) => {
  try {
    let apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/userNotification/seen`
    const data = { notifications }
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      throw `post seenUserNotification failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const muteUserNotifications = async (notifications) => {
  try {
    let apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/userNotification/mute`
    const data = { notifications }
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      throw `post muteUserNotification failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}
